__turbopack_context__.v({
  "my_list_confirm_removal_modal": "MyListConfirmRemovalModal-module-scss-module__RlBUvG__my_list_confirm_removal_modal",
  "my_list_confirm_removal_modal_buttons": "MyListConfirmRemovalModal-module-scss-module__RlBUvG__my_list_confirm_removal_modal_buttons",
  "my_list_confirm_removal_modal_inner": "MyListConfirmRemovalModal-module-scss-module__RlBUvG__my_list_confirm_removal_modal_inner",
  "my_list_confirm_removal_modal_text": "MyListConfirmRemovalModal-module-scss-module__RlBUvG__my_list_confirm_removal_modal_text",
});
